module.exports = __webpack_public_path__ + "static/media/Logo__Balsamiq.11da697f.svg";